module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5NjAiIGhlaWdodD0iNDgwIj48cGF0aCBmaWxsPSIjMjM5ZTQ2IiBkPSJNMCAwaDk2MHY0ODBIMHoiLz48cGF0aCBkPSJNMCAwaDk2MHYzNjBIMHoiLz48cGF0aCBmaWxsPSIjZTcwMDEzIiBkPSJNMCAwaDk2MHYxMjBIMHoiLz48Y2lyY2xlIGN4PSI0ODAiIGN5PSIyNDAiIHI9IjYwIiBmaWxsPSIjZmZmIi8+PGNpcmNsZSBjeD0iNDkyLjEzMiIgY3k9IjI0MCIgcj0iNTIuMTMyIi8+PHBhdGggZD0iTTUwOS4xNzUgMjQwbDgwLjctMjYuMjIxTDU0MCAyODIuNDI2di04NC44NTJsNDkuODc1IDY4LjY0N3oiIGZpbGw9IiNmZmYiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/lby.svg
// module id = 7CDZ
// module chunks = 0